/**
 * @generated SignedSource<<44740e0f599cf23fde7ac25cf45f343d>>
 * @relayHash de75149bd6de46cf773dd86b1156f83a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ebe912401833398260e3dd424a76d9025c2d0e3981e3849b1cfa056f97e79e8b

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type SettingsCreationSettingsInput = {
  autoApply?: boolean | null | undefined;
  ownerAri: string;
  properties?: ReadonlyArray<SettingsCreationPropertyInput> | null | undefined;
  tenantId: string;
};
export type SettingsCreationPropertyInput = {
  key: string;
  value: string;
};
export type creationSettingsMutationMutation$variables = {
  input: SettingsCreationSettingsInput;
};
export type creationSettingsMutationMutation$data = {
  readonly settings_updateCreationSettings: {
    readonly autoApply: boolean | null | undefined;
    readonly id: string;
  } | null | undefined;
};
export type creationSettingsMutationMutation = {
  response: creationSettingsMutationMutation$data;
  variables: creationSettingsMutationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SettingsCreationSettings",
    "kind": "LinkedField",
    "name": "settings_updateCreationSettings",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "autoApply"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "creationSettingsMutationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "creationSettingsMutationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ebe912401833398260e3dd424a76d9025c2d0e3981e3849b1cfa056f97e79e8b",
    "metadata": {},
    "name": "creationSettingsMutationMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2764b2132df7149a218d7fe86758b452";

export default node;
